import {FormField} from "../form-field/form-field";
import {GvfService} from "../../../gvf/js/gvf-service";

export class FormFieldFiles extends FormField{
    constructor(scope,$root){
        super(scope,$root);
        this.$dropZone = null;
        this.$input = null;
    }

    getVal(){
        return this.$input.val();
    }

    setVal(val,noEvent){
        if($.isArray(val)){
            val = JSON.stringify(val);
        }
        this.$dropZone.dropzoneSetValue(val);
        this.$input.val(val);
        if(!noEvent){
            this.$root.trigger("formField:changeVal");
        }
    }

	ready(){
        super.ready();
        this.$dropZone = this.findMember("files");
        this.$input = this.findMember("input");

        this.$dropZone.on("dropzone:change",()=>{
            GvfService.delay(100,"formFieldFiles:changeVal").then(()=>{
                this.$root.trigger("formField:changeVal");
            });
        });
    }
}

